import script from "./ProductReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductReviews.vue?vue&type=script&setup=true&lang=js"

import "./ProductReviews.vue?vue&type=style&index=0&id=047f074d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047f074d"]])

export default __exports__